import script from "./ProjectView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectView.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectView.vue?vue&type=style&index=0&id=b9f03f34&scoped=true&lang=scss"
import "./ProjectView.vue?vue&type=style&index=1&id=b9f03f34&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9f03f34"]])

export default __exports__